import {
  InfoModule,
  createInfoServices
} from "./chunk-BIQX33UG.mjs";
import "./chunk-KEIR6QF5.mjs";
export {
  InfoModule,
  createInfoServices
};
